import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
import { dilKodu } from '../kimlik/kullanici.js';
import { cihazPlatformu } from '../bildirim/cihaz-kayit.js';
export const cinsiyet = z.enum(['ERKEK', 'KADIN', 'BELIRTILMEMIS']);
export const musteriCihazOzeti = z.object({
    platform: cihazPlatformu,
    cihazAdi: z.string().nullable(),
    uygulamaSurum: z.string().nullable(),
    sonGorulme: z.string().datetime(),
});
export const musteri = z.object({
    id: z.string(),
    telefon: z.string(),
    ulkeKodu: z.string(),
    eposta: z.string().nullable().optional(),
    adSoyad: z.string(),
    dogumTarihi: z.string().nullable().optional(),
    cinsiyet,
    dilTercihi: dilKodu,
    aktif: z.boolean(),
    cuzdanBakiyesi: z.string(),
    cuzdanParaBirimi: paraBirimi,
    sonGirisTarihi: z.string().datetime().nullable().optional(),
    anonimlestirildiMi: z.boolean(),
    kayitTarihi: z.string().datetime(),
    toplamKiralama: z.number().int().nullable().optional(),
    cihaz: musteriCihazOzeti.nullable().optional(),
});
export const musteriSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    arama: z.string().optional(),
    aktif: z.coerce.boolean().optional(),
});
//# sourceMappingURL=musteri.js.map